<template>
  <div
    class="absolute transition-all duration-300"
    :style="{
      top: timeslot.position.top,
      left: timeslot.position.left
    }"
  >
    <div
      class="border border-l-4 border-tomato-700 rounded-lg bg-pure-white p-2 flex flex-col justify-between gap-1 shadow-md transition-all duration-300"
      :style="{
        height: timeslot.element.height,
        width: timeslot.element.width
      }"
    >
      <div
        class="px-1 h-full flex flex-col gap-1 justify-center bg-tomato-700 rounded overflow-y-hidden cursor-pointer"
        :class="{ 'cursor-pointer': currentUser.role.includes('admin') }"
        @click="onOpenModal"
      >
        <div v-if="slotCount > 1">
          <BlIcon icon="warning" color="secondary" class="h-6 w-6" />
        </div>
        <div>
          <BlTextSubtitle3
            v-if="!isCompact"
            text="Overlapping availabilities detected in these slots."
            class="text-pure-white"
          />
          <BlTextBody2 text="Click to resolve." class="text-pure-white" />
        </div>
      </div>
      <ResolveOverlappedModal
        v-if="modalOpened"
        :overlapped="item"
        @close-modal="modalOpened = false"
        @after-commit="$emit('after-commit')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CLOCK_ROUND } from "@/plugins/assets.js";

import ResolveOverlappedModal from "../overlapped/ResolveOverlappedModal.vue";
import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlIcon from "../../BlIcon.vue";

export default {
  name: "AppointmentsAvailableTimeslot",
  components: {
    ResolveOverlappedModal,
    BlTextSubtitle3,
    BlTextBody2,
    BlIcon
  },
  props: {
    isCompact: { type: Boolean, default: false },
    item: { type: Object, required: true },
    headers: { type: Array, required: true },
    slotHeight: { type: Number, required: true }, // in rem
    slotWidth: { type: String, required: true }
    // @after-commit
  },
  data() {
    return {
      modalOpened: false,
      clockRound: CLOCK_ROUND
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    slotType() {
      // all, therapist, room
      return this.$route.params.tab || "all";
    },
    slotCount() {
      return this.getSlotCount(this.item.start_time, this.item.end_time);
    },
    timeslot() {
      const keyHeaders = this.headers.map(i => i.value);

      const item = { ...this.item };
      const position = {
        top: "calc(",
        left: "calc(5rem"
      };
      const element = {
        height: ``,
        width: `calc(${this.slotWidth} - 2px)`
      };

      const indexOfTop = this.clockRound.findIndex(i => {
        const dt = i.split(":")[0];
        return dt === item.start_time.split(":")[0];
      });
      position.top += indexOfTop * (this.slotHeight * 2) + "rem";
      if (item.start_time.split(":")[1] === "30") {
        position.top += ` + ${this.slotHeight}rem`;
      }
      position.top += " + 0.5px)";

      const indexOfLeft = keyHeaders.findIndex(i => i === item.key.id);
      if (indexOfLeft > -1) {
        const loop = indexOfLeft;
        for (let index = 0; index < loop; index++) {
          position.left += ` + ${this.slotWidth}`;
        }
      }
      position.left += " + 0.5px)";

      const calculatedHeight =
        this.getSlotCount(item.start_time, item.end_time) * this.slotHeight;
      element.height = `calc(${calculatedHeight}rem - 2px)`;

      return { ...item, position, element };
    }
  },
  mounted() {},
  methods: {
    onOpenModal() {
      if (this.currentUser.role.includes("admin")) {
        this.modalOpened = true;
      }
    },
    getSlotCount(start, end) {
      const s = start.split(":").map(i => Number(i));
      const e = end.split(":").map(i => Number(i));
      let slots = 0;
      slots += (e[0] - s[0]) * 2;
      if (s[1] === 30) slots -= 1;
      if (e[1] === 30) slots += 1;
      return slots;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/appointments/timeslot/OverlappedTimeslot.vue